import { logWarning } from '@databases/logs';
import { getDatabaseWithCurrentView } from '@databases/redux/database-view';
import { type DefaultRootState } from '@databases/redux/default-root-state';
import { isBrokenDatabase } from '@databases/utils/database/utils';
import { selectThreadByValueIdOptional } from '@databases/utils/redux/comments/selectors';
import { getValueId } from '@databases/utils/utils';

import { type ThreadWithValueId } from '../type';

export function selectAllVisibleUnresolvedThreads(
  state: DefaultRootState,
  { contentId }: { contentId: string }
): ThreadWithValueId[] {
  try {
    const database = getDatabaseWithCurrentView(state, { contentId });

    if (!database || isBrokenDatabase(database)) {
      return [];
    }

    const orderedThreads = database.entries.flatMap((entryId) =>
      database.fields.flatMap((fieldId) => {
        const threads = selectThreadByValueIdOptional(state, {
          contentId,
          fieldId,
          entryId
        });
        return threads
          ? threads
              .filter((thread) => !thread.isResolved)
              .map((thread) => ({
                ...thread,
                valueId: getValueId(entryId, fieldId)
              }))
          : [];
      })
    );
    return orderedThreads;
  } catch (e: unknown) {
    if (e instanceof Error) {
      logWarning('Error selecting visible unresolved threads', e);
    }
    return [];
  }
}
